<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="30%"
            @close="handleClose"
        >
            <el-form :model="form" label-width="100px" :rules="rules" ref="form">
                <el-form-item label="分类名称" prop="categoryName">
                    <el-input v-model.trim="form.categoryName" placeholder="请输入分类名称"></el-input>
                </el-form-item>
                <!-- <el-form-item label="分类排序" prop="showOrder">
                    <el-input v-model.number="form.showOrder" placeholder="请输入分类排序"></el-input>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleConfirm">确定</el-button>
                <el-button @click="handleCancel">取消</el-button>   
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'SalesCategoryDialog',
    props: {
        //打开方法
        title: {
            type: String,
            default: '添加分类'
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                categoryName: '',
                // showOrder: 1,
                id: ''
            },
            rules: {
                categoryName: [
                    { required: true, message: '请输入分类名称', trigger: 'blur' }
                ],
                // showOrder: [
                //     { required: true, message: '请输入分类排序', trigger: 'blur' }
                // ]
            }
        }
    },
    methods: {
        // 确认时触发，传递给父组件
        handleConfirmEmit(form) {
            this.$emit('confirm', form)
        },
        // 确认时触发，关闭弹窗
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.handleConfirmEmit(this.form)
                    this.handleCancel()
                } else {
                    return false
                }
            })
        },
        handleCancel() {
            this.dialogVisible = false
        },
        handleDialogVisible() {
            this.dialogVisible = true
        },
        handleEdit(e) {
            this.form = {...e}
            this.handleDialogVisible(e)
        },
        handleClose() {
            this.form = {
                categoryName: '',
                id: ''
                // showOrder: 1
            }
            this.handleCancel()
        }
    }
}
</script>


<style scoped lang="scss">

</style>